import type { PetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';

type Params = {
	decisionMaker: boolean;
	signed: boolean;
	status: PetitionDetailsPageData['petition']['status'];
	unauthenticatedSignFormEnabled: boolean;
};

/**
 * Whether the mobile action button renders a sign CTA for this viewer, as opposed to a respond,
 * share or combo button.
 *
 * Single source of truth for `MobileActionButtonContainer`'s branching. Experiments scoped to the
 * sign CTA read it to decide who is even addressable — without one shared predicate the two drift,
 * and an experiment silently starts bucketing viewers who see a different button entirely.
 * `MobileActionButton.test.tsx` pins the component's rendering to this function.
 */
export function rendersSignCta({ decisionMaker, signed, status, unauthenticatedSignFormEnabled }: Params): boolean {
	if (decisionMaker) return false;
	if (status === 'CLOSED' || status === 'VICTORY') return false;
	if (signed && !unauthenticatedSignFormEnabled) return false;

	return true;
}
